// Stable selector for locating the widget in the DOM from outside the widgets tree (e.g. the gift
// claim flourish that flies a claimed pack toward this entry point). Kept in its own dependency-free
// module so consumers don't have to pull in the store graph just to reference the id.
export const CROWN_RIPS_WIDGET_TEST_ID = 'crown-rips-widget';

// One-shot arrival pulse duration (see CrownRipsStore.widgetPulseNonce) — kept in sync with the
// `.pulse` keyframe animation's duration in CrownRipsWidget.module.scss.
export const WIDGET_PULSE_DURATION_MS = 300;

// The pending-packs count badge displays "9+" beyond this, rather than growing unbounded in a
// compact pill.
export const PENDING_PACKS_DISPLAY_CAP = 9;
